<template>
  <div class="bg-green-50 page-section pt-5 -mb-5">
    <div class="container">
      <div class="row">
        <div class="col-lg-6 py-3 wow zoomIn">
          <div class="img-place text-center hidden lg:flex">
            <img src="../assets/pdp.jpg" alt="" />
          </div>
        </div>
        <div class="col-lg-6 p-4">
          <h2 class="title-section text-2xl">
            All About
            <span class="marked">Myself</span>
          </h2>
          <div class="divider"></div>

          <div>
            <p>
              Being currently in training specialized in computer science within
              the school of engineering CESI, I am at ease with the work in
              group as well as the relational contact. I consider myself
              open-minded, hard-working and diligent in everything I do. I adapt
              easily while being receptive.
            </p>
          </div>

          <div>
            <p>
              As I am passionate about electronics, project creation and new
              technology, my aim is to combine my skills in order to draw up a
              concrete project.
            </p>
          </div>
        </div>
      </div>
    </div>
    <!-- .container -->
  </div>
  <!-- .page-section -->

  <div class="bg-green-50 page-section">
    <div class="container">
      <div class="row">
        <div class="col-lg-6 p-4 -mt-9 lg:mt-0">
          <h2 class="title-section text-2xl">
            My
            <span class="marked">Skills & Experiences</span>
          </h2>
          <div class="divider"></div>
          <p class="mb-4">
            I am currently in my 5th and final year of engineering school at
            CESI, in Reims. With proposed specialties such as data science and
            project management, this course allows me today to manage and work
            on a project independently
          </p>
          <p class="mb-4">
            I like to develop my skills in different types of projects that are
            offered to me, with the desire to join my soft skills
            (Communication, presentation of results and strong sense of
            professionalism) with hard skills that I was able to learn with my
            experience (prediction algorithms, processing and data management,
            report/BI of a raw dataset, computer vision, etc.)
          </p>

          <router-link to="/projects" class="btn btn-outline ml-2">
            My Projects
          </router-link>
        </div>
        <div class="col-lg-6 py-3 wow zoomIn">
          <div class="img-place text-center">
            <img src="../assets/experiences.jpg" alt="" />
          </div>
        </div>
      </div>
    </div>
    <!-- .container -->
  </div>
  <Footer />
</template>

<script>
import Footer from "./Footer.vue";
export default {
  data() {
    return {
      scrollPosition: 0,
    };
  },

  methods: {
    handleScroll(e) {
      this.scrollPosition = e.target.scrollTop;

      if (this.scrollPosition > 100) {
        console.log("UP");
      } else {
        console.log("DOWN");
      }
    },
  },
  components: {
    Footer,
  },
};
</script>

<style scoped>
img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  object-position: center;
  border-radius: 10%;
}

.zoomIn:hover {
  transform: scale(1.05);
  transition: all 0.5s ease;
}
</style>
